import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ClickMetric } from '../../admin/models/monitoring/click-monitoring.model';
import { ClicksMonitorService } from './clicks-monitor.service';
import { exportFile } from '@core/_utils/exportFile';
import { getLastWeek, getNextDay, getToday } from '@core/_utils/date';
import { upperFirst } from 'lodash';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'kt-clicks-monitoring',
  templateUrl: './clicks-monitor.component.html',
  styleUrls: ['../../max-width-page-view-components.scss'],
})
export class ClicksMonitorComponent implements OnInit, OnDestroy {
  public clicksData: ClickMetric[] = [];
  public data: ClickMetric[] = [];
  public pageSizeOptions: number[] = [10, 25, 50, 100];
  public minDate = getLastWeek();
  public maxDate = getToday();
  public loadClicksMetrics = false;
  public loadExportClicksMetrics = false;

  private activity$ = new Subject();
  private unsubscribe$ = new Subject();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private clicksMonitorService: ClicksMonitorService,
    private changeDetector: ChangeDetectorRef,
    private transloco: TranslocoService,
  ) {}

  ngOnInit() {
    this.observeRangeDate();
    this.activity$.next({});
  }

  public exportReport() {
    this.loadExportClicksMetrics = true;

    this.clicksMonitorService
      .exportExcel(this.minDate, getNextDay(this.maxDate), this.transloco.getActiveLang())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.loadExportClicksMetrics = false;
        exportFile('clicks-analytics')(data);
      });
  }

  public pageEvent($event) {
    this.data = this.sliceData(this.clicksData, $event.pageIndex, $event.pageSize);
  }

  public sliceData(data, pageIndex, pageSize) {
    return data.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);
  }

  public getDefaultPageSize() {
    return this.pageSizeOptions[0];
  }

  public setMinDate($event) {
    this.minDate = $event;
    this.activity$.next({});
  }
  public setMaxDate($event) {
    this.maxDate = $event;
    this.activity$.next({});
  }

  private observeRangeDate() {
    this.activity$.pipe(takeUntil(this.unsubscribe$)).subscribe(this.getByDateRange);
  }

  private getByDateRange = () => {
    this.loadClicksMetrics = true;

    return this.clicksMonitorService
      .getByDateRange(this.minDate, getNextDay(this.maxDate))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((clicksData) => {
        this.clicksData = clicksData;
        this.data = this.sliceData(clicksData, 0, this.getDefaultPageSize());
        this.loadClicksMetrics = false;
        this.changeDetector.detectChanges();
      });
  };

  getTitle(item) {
    const lang = upperFirst(this.transloco.getActiveLang());
    return item[`title${lang}`];
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
